import React from "react";
import image from "../assets/images/rs-img.png";
import { FaYoutube, FaInstagram, FaTiktok } from "react-icons/fa";
import bulle from "../assets/images/bulle_reseaux.svg";

function ReseauxSociaux() {
	return (
		<>
			<div className="home-reseaux__bulle">
				<img src={bulle} alt="Retrouve plein d'infos sur nos réseaux" />
			</div>
			<div className="home-reseaux">
				<div className="home-reseaux__image-container">
					<img src={image} alt="Un tampon joyeux avec des jambes et un chapeau" />
				</div>
				<div className="home-reseaux__right-container">
					<div className="home-reseaux__title-container">
						<p className="home-reseaux__title">
							C'est par ici
						</p>
					</div>
					<div className="home-reseaux__link-container">
						<a rel="noreferrer" tabIndex="0" className="focused" target="_blank" href="https://www.youtube.com/@ParlonsRegles" aria-label="Parlons Règles sur YouTube">
							<FaYoutube className="footer__rs-ico" />
						</a>						
						<a rel="noreferrer" tabIndex="0" className="focused" target="_blank" href="https://www.instagram.com/regleselementaires/" aria-label="Parlons Règles sur Instagram">
							<FaInstagram className="footer__rs-ico" />
						</a>						
						<a rel="noreferrer" tabIndex="0" className="focused" target="_blank" href="https://www.tiktok.com/@regleselementaires" aria-label="Parlons Règles sur TikTok">
							<FaTiktok className="footer__rs-ico" />
						</a>
					</div>
				</div>
			</div>
		</>
	);
}

export default ReseauxSociaux;
